import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'cards/actions/modalActions';
import { getCardSettings } from 'cards/util/cardSettingsUtils';
import { CARD_TYPES } from 'cards/constants/CardTypes';
import type { WCardSuiteSummaryView } from '@zola/svc-web-api-ts-client';
import { useMostPopularSamplesFromFamily } from '../util/hooks';
import { CardSuiteInfoSummary } from '../util/types';

import FeatureFlags from '../../../../../util/featureFlags';

interface SingleSampleAccessPointProps {
  familyName?: string;
  displayComponent: ReactElement;
  sampleCardType?: string;
  cardSuiteInfoSummary?: CardSuiteInfoSummary;
  cardSuiteFilterFn?: (suites: WCardSuiteSummaryView[]) => WCardSuiteSummaryView;
  isDigital?: boolean;
  shouldUseExperiment?: boolean; // Used to switch between using dstd wedding website entrypoint experiment vs feature flag
  isUnderDstdWebsiteEntrypointTest?: boolean;
}
const SingleSampleAccessPoint: React.FC<SingleSampleAccessPointProps> = ({
  familyName,
  displayComponent,
  sampleCardType = CARD_TYPES.invitation,
  cardSuiteInfoSummary,
  cardSuiteFilterFn,
  isDigital,
  shouldUseExperiment = false,
  isUnderDstdWebsiteEntrypointTest,
}) => {
  const cardSuiteInfo =
    cardSuiteInfoSummary ||
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useMostPopularSamplesFromFamily(familyName, sampleCardType, cardSuiteFilterFn);
  const dispatch = useDispatch();

  if (!cardSuiteInfo) return null;

  const {
    uuid,
    cardType,
    isMagnet,
    singleSampleAvailable,
    singleSampleSku,
    sampleCard,
  } = cardSuiteInfo;

  // TODO: Confirm response returns only suites that are available
  if (
    shouldUseExperiment &&
    ((!isUnderDstdWebsiteEntrypointTest && !singleSampleAvailable) ||
      (isUnderDstdWebsiteEntrypointTest && !singleSampleAvailable && !isDigital))
  ) {
    return null;
  }

  if (
    !shouldUseExperiment &&
    ((!FeatureFlags.get('dstdWebsiteEntry') && !singleSampleAvailable) ||
      (FeatureFlags.get('dstdWebsiteEntry') && !singleSampleAvailable && !isDigital))
  ) {
    return null;
  }

  function handleOpenModal(overrideProps = {}): void {
    if (!uuid) return;

    const modalProps = {
      entryPoint: 'WEBSITE',
      cardNameList: [sampleCard?.lead_card?.name],
      cardSuiteUUIDList: [uuid],
      cardUUIDList: [singleSampleSku],
      isMagnet,
      selectedColorSet: {
        [uuid]: sampleCard?.lead_card?.colors && sampleCard.lead_card.colors[0].value,
      },
      ...overrideProps,
    };

    dispatch(openModal('SAMPLES_MODAL', modalProps));
  }

  return (
    <>
      {React.cloneElement(displayComponent, {
        handleOpenModal,
        cardTypeLabel: getCardSettings(cardType).label,
        singleSampleAvailable,
        cardSuiteInfo,
      })}
    </>
  );
};

export default SingleSampleAccessPoint;
